import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { BreadcrumbService, ErrorMessageService } from '@library/core/services';
import { ErrorMessage } from '@library/common/http';

@Component({
   selector: 'lib-default-error',
   styles: [
      `.error-message {
         font-weight: bold;
         font-size: 1.2em;
      }`
   ],
   templateUrl: './default.error.component.html',
})
export class DefaultErrorComponent implements OnDestroy {
   messages: ErrorMessage[] = [];
   processId: string;

   constructor(
      public error: ErrorMessageService,
      private breadcrumbs: BreadcrumbService,
      private router: Router,
   ) {
      this.breadcrumbs.addCrumble( 'error' );
      
      // Get error messages from navigation state
      const navigation = this.router.getCurrentNavigation();
      const state = navigation?.extras?.state || this.router.routerState.root.snapshot.data;
      this.processId = state?.['processId'];
      
      if (state?.['errors']) {
         const msgs = state['errors'];
         if (Array.isArray(msgs)) {
            msgs.forEach(msg => {
               if (typeof msg === 'string') {
                  this.messages.push(new ErrorMessage({
                     id: this.messages.length + 1,
                     type: 'error',
                     code: 'Default',
                     message: msg,
                  }));
               } else if (msg?.message) {
                  this.messages.push({ ...msg, id: this.messages.length + 1 });
               }
            });
         }
      } else {
         console.log( 'no errors found' );
         this.router.navigate([ '/' ]);
      }
   }

   ngOnDestroy() {
      this.error.reset();
      this.messages = [];
   }
}
